export const SysWrapper = ({ children }: { children: React.ReactNode }) => {
  return <div className=" text-[#A3A3A3] text-[14px] text-center">{children}</div>;
};
